import { Field } from "../../field";
import { BusinessOwner } from "../../fieldsets";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";

export class FirstNameField extends Field<string> {
  protected readonly _owner: BusinessOwner | null;

  constructor(
    model: Merchant,
    owner: BusinessOwner | null,
    opts: Partial<MerchantField<string>> = {}
  ) {
    super(model, {
      dataType: "string",
      testValue: "John",
      propertyName: "firstName",
      uiFieldType: "Input",
      uiInputBaseProps: {
        autoComplete: "given-name",
      },
      applicable: true,
      shown: true,
      required: true,
      ...opts,
    });

    this._owner = owner;
  }
}
